module.exports = __webpack_public_path__ + "static/media/icon_call_fancy.f13008b4.svg";